<template>
  <div class="inactiveClientClass">
    <div class="o-ndividualTable" v-loading="loading">
      <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10" style="overflow:auto;">
        <div class="o-custom-table-container c-common-box-shadow c-radius3 inactive-client-list-table-align" v-for="(client,key) in clients" v-if="client.user && client.user.length !=0">
            <div class="o-calls-table c-common-gradient">
                <div class="calls-table-row phonesheet-table-row">
                    <div class="calls-table-cell">
                        <div class="table-td-border-right">
                            <div class="calls-table-cell-inner-table">
                                <div class="o-accordion-subtext o-rowtable-text">
                                    <span>Client:</span>
                                    <div>{{client.user.first_name+" "+client.user.last_name}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="calls-table-cell">
                        <div class="table-td-border-right">
                            <div class="o-accordion-subtext o-rowtable-text">
                                <span>Contact Person:</span>
                                <div>{{client.contact_person}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="calls-table-cell">
                        <div class="table-td-border-right">
                            <div class="calls-table-cell-inner-table">
                                <div class="o-accordion-subtext o-rowtable-text">
                                    <span>Phone:</span>
                                    <div>{{client.contact_phone}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="calls-table-cell">
                        <div class="table-td-border-right">
                            <div class="calls-table-cell-inner-table">
                                <div class="o-accordion-subtext o-rowtable-text">
                                    <span>Email ID:</span>
                                    <div>{{client.user.email}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="calls-table-cell">
                        <div class="table-td-border-right">
                            <div class="o-accordion-subtext o-rowtable-text">
                                <span>Users:</span>
                                <div>{{client.client_employees.length+"/"+(client.max_user == 999999?'Unlimited':client.max_user)}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="calls-table-cell">
                        <div class="table-td-border-right">
                            <div class="o-accordion-subtext o-rowtable-text">
                                <span>Sign up:</span>
                                <div>{{client.created_at}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="calls-table-cell">
                        <div class="">
                            <div class="o-accordion-subtext o-rowtable-text">
                                <span>Notes:</span>
                                <div>{{client.note}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="calls-table-cell">
                        <div class="">
                            <div class="o-accordion-subtext o-rowtable-text text-center">
                                <a href="javascript: void(0)" @click="goToLogin(client.subdomain, client.user?client.user.id:'')" class="o-client-view"><i class="fa fa-eye" aria-hidden="true"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="o-table-extend-area u-pad-all-5 text-left o-table-extend-area--superadmin">
                <ul class="o-table-extend">
                    <li>
                        <a href="javascript: void(0)" @click="editClient(client)" class="o-super-edit-icon">
                            <i class="fa fa-pencil" aria-hidden="true"></i> Edit
                        </a>
                    </li>
                    <li>
                        <a href="javascript: void(0)" @click="goToManageEx(client)" class="o-super-manage-icon">
                            <i class="fa fa-server" aria-hidden="true"></i> Manage Exceptions
                        </a>
                    </li>
                    <li>
                        <a href="javascript: void(0)" @click="activate(client.id,key)" class="o-super-deactive-icon">
                            <i class="fa fa-eye-slash" aria-hidden="true"></i> Activate
                        </a>
                    </li>
                    <li>
                        <a href="javascript: void(0)" @click="deleteClient(client.id,key)" class="o-super-delete-icon">
                            <i class="fa fa-trash" aria-hidden="true"></i> Delete
                        </a>
                    </li>
                </ul>
            </div>
        </div>
      </div>
      <div v-if="clients.length == 0 && afterAPI == true" class="c-common-space c-responsive-fixwidth c-common-gradient c-common-box-shadow c-radius3">
         <div class="col-md-12 no-job-dispaly">
            <i class="fa fa-frown-o" aria-hidden="true"></i>
            <br />
             No Data Stored
         </div>
      </div>
    </div>
  </div>
</template>
<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import service from '../../services.js';
    import {
        global
    } from '../../global.js';
    export default {

        computed: {
            ...mapGetters({
                userToken: 'userToken'

            })
        },
        props: ['myProp'],
        watch: {
            myProp: function(newVal) {
                if (newVal == "") {
                    this.getClientList();
                } else {
                    if (newVal.length > 3) {
                        service.get('client/searchClient', {
                                'Authorization': this.userToken,

                                'searchClient': newVal
                            })
                            .then((res) => {
                                this.searchData = res.data.result;

                                this.clients = [];
                                for (var i = 0; i < this.searchData.length; i++) {
                                    if (this.searchData[i].is_active == 0) {
                                        this.clients.push(this.searchData[i]);

                                    }


                                }
                            }).catch((err) => {
                                console.log(err);
                            })
                    }
                }
            }
        },
        data() {
            return {
                loading:false,
                clients: [],
                next_page_url: null,
                savedClients: [],
                afterAPI: false
            }
        },
        methods: {
            loadMore() {
                var arr = this.clients;
                if (this.savedClients.length != 0) {
                    this.savedClients.forEach(function(entry) {
                        arr.push(entry);
                    })

                    if (this.next_page != null) {
                        service.get('client', {
                                'Authorization': this.userToken
                            })
                            .then((newClients) => {
                                this.savedClients = newClients.data.result.data;
                                this.next_page_url = newClients.data.result.next_page_url;


                            }).catch((err) => {
                                console.log(err);
                            });
                    }
                } else
                    this.savedEmployees = [];
            },
            editClient(client) {
                this.$store.dispatch('setClient', {
                    'id': client.id

                });
                this.$router.push({
                    'path': '/editClient'
                });
            },
            goToManageEx(client) {
                this.$store.dispatch('setClient', {
                    'id': client.id

                });
                this.$router.push({
                    'path': '/manageExceptions'
                });
            },
            deleteClient(id, key) {
                this.$confirm('This will permanently delete the client. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.loading=true;
                   //console.log('deleting');
                    service.del('client/' + id, {
                        'Authorization': this.userToken
                    })
                    .then((res) => {
                        this.loading=false;
                        this.$notify({
                            title: this.$t('success'),
                            message: 'Client Deleted Successfully.',
                            type: 'success'
                        });
                        this.clients.splice(key, 1);
                        this.$router.push({
                            'path': '/clientList'
                        });
                    }).catch((err) => {
                        this.loading=false;
                        console.log(err);
                    });
                    // var self=this;
                    // setTimeout(function(){ 
                    //     self.loading=false;
                    // }, 5000);

                    //console.log(id);
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Delete canceled'
                    });
                });
            },
            activate(id, key) {
                this.$confirm('This will activate the selected client. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    service.post('client/' + id + "/changeStatus", {
                            status: 1
                        }, {
                            'Authorization': this.userToken
                        })
                        .then((res) => {
                            this.$notify({
                                title: this.$t('success'),
                                message: 'Client Activated Successfully.',
                                type: 'success'
                            });
                            this.clients.splice(key, 1);

                        }).catch((err) => {
                            console.log(err);
                        });
                    //console.log(id);
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Activation cancelled'
                    });
                });
            },
            getClientList() {
                this.$Progress.start();
                this.loading=true;
                service.get('client/inactiveClients', {
                        'Authorization': this.userToken
                    })
                    .then((res) => {
                        this.$Progress.finish();
                        this.clients = res.data.result.data;
                        this.next_page_url = res.data.result.next_page_url;
                        this.loading=false;
                        this.afterAPI = true;
                        if (res.data.result.next_page_url != null) {
                            service.get('client', {
                                    'Authorization': this.userToken
                                })
                                .then((newClients) => {

                                    this.savedClients = newClients.data.result.data;
                                    this.next_page_url = newClients.data.result.next_page_url;
                                    

                                }).catch((err) => {
                                    console.log(err);
                                });
                        }

                    }).catch((err) => {
                        console.log(err);
                    });
            },
            goToLogin(subdomain , clientId) {
                this.$Progress.start();
                service.get('universal_login', {
                    'Authorization': this.userToken,
                    'userid': clientId,
                    'url': "http://" + subdomain + "." + global[0].CLIENT_BASE,
                })
                .then((res) => {
                    // console.log(res);
                    if (res.data.status_message != "Login successful") {
                        this.$Progress.fail();
                        //this.credential_err = "Invalid Login Credentials";
                        //console.log('incorrect');
                    } else {
                        //console.log('correct');
                        this.$store.dispatch('userSession', res);
                        this.$cookies.set("csLogin", res.data.role.slug, "23h");
                        this.$cookies.set("date_format", res.data.user.employees[0].date_format, "23h");
                        this.$cookies.set("time_format", res.data.user.employees[0].time_format, "23h");
                        //console.log('timezone', res.data.user.employees[0].client[0].clients.timezone);
                        //this.credential_err = "";
                        this.$Progress.finish();
                        $('.wrapper').css('margin-left', '60px');
                        //console.log('res.data.role.slug', res.data.role.slug);
                        //console.log(res.data.user.employees[0].date_format);
                        //console.log(res.data.user.employees[0].time_format);
                        if (res.data.role.slug != "super-admin") {
                            this.$cookies.set("time_zone", res.data.user.employees[0].client[0].clients.timezone, "23h");
                            var notifyType = (res.data.user.employees[0].email_notification == 1) ? 'email' : 'sms';
                            this.$store.dispatch('setNotificationType', notifyType);
                            this.$store.dispatch('setClientdata', res.data.user.employees[0].client[0].clients);
                            //var temp={'parent': 'Myjob', 'child': 'Myjob'};
                            this.$store.dispatch('setSelectedJobFilter', {'parent': 'Myjob', 'child': 'Myjob'});

                            if (res.data.role.slug == "client-admin" || res.data.role.slug == "power-user") {
                                this.$router.push({
                                    path: "/jobList"
                                });
                            } else {
                                this.$router.push({
                                    path: "/schedule/"+btoa(this.employeeId),
                                });
                            }

                        } else {
                            this.$router.push({
                                path: "/clientList"
                            });
                        }

                    }
                    //window.location.href = "http://" + subdomain + "." + global[0].CLIENT_BASE;
                }).catch((err) => {
                    console.log(err);
                });
                //return "http://" + subdomain + "." + global[0].CLIENT_BASE;
            }
        },
        created() {
            this.getClientList();

        }
    }

</script>



// WEBPACK FOOTER //
// src/components/superAdmin/inactiveClient.vue